<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <div id="dashboard-analytics">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <router-link :to="'/company/appointment'">
            <b-card class="pt-5 pb-5 custom-height">
              <b-card-text class="text-center">
                <feather-icon
                  svgClasses="w-7 h-7 text-primary stroke-current"
                  icon="CalendarIcon"
                />
              </b-card-text>
              <b-card-title class="text-center">
                {{ countAppointment }}
              </b-card-title>
              <b-card-text class="text-center">
                {{ $t("TotalAppointments") }}
              </b-card-text>
            </b-card>
          </router-link>
        </div>

        <!-- Complete -->
        <div class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <router-link :to="'/company/appointment'">
            <b-card class="pt-5 pb-5 custom-height">
              <b-card-text class="text-center">
                <feather-icon
                  svgClasses="w-7 h-7 text-success stroke-current"
                  icon="CalendarIcon"
                />
              </b-card-text>
              <b-card-title class="text-center">
                {{ countCompleted }}
              </b-card-title>
              <b-card-text class="text-center">
                {{ $t("CompletedAppointments") }}
              </b-card-text>
            </b-card>
          </router-link>
        </div>
        <!--  -->

        <!-- Pending -->
        <div class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <router-link :to="'/company/appointment'">
            <b-card class="pt-5 custom-height">
              <b-card-text class="text-center">
                <feather-icon
                  svgClasses="w-7 h-7 text-warning stroke-current"
                  icon="CalendarIcon"
                />
              </b-card-text>
              <b-card-title class="text-center">
                {{ countPending }}
              </b-card-title>
              <b-card-text class="text-center">
                {{ $t("PendingAppointments") }}
              </b-card-text>
            </b-card>
          </router-link>
        </div>
        <!--  -->

        <!-- Cancelled -->
        <div class="vx-col w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
          <router-link :to="'/company/appointment'">
            <b-card class="pt-5 custom-height">
              <b-card-text class="text-center">
                <feather-icon
                  svgClasses="w-7 h-7 text-danger stroke-current"
                  icon="CalendarIcon"
                />
              </b-card-text>
              <b-card-title class="text-center">
                {{ countCancelled }}
              </b-card-title>
              <b-card-text class="text-center">
                {{ $t("CancelledAppointments") }}
              </b-card-text>
            </b-card>
          </router-link>
        </div>
        <!--  -->
      </div>

      <div class="vx-row">
        <div class="vx-col w-1/2">
          <chartjs-doughnut-chart
            :height="height"
            title="Appointment Status"
            :data="appointmnetData"
          ></chartjs-doughnut-chart>
        </div>
        <div class="vx-col w-1/2">
          <chartjs-line-chart
            :title="appTitle"
            :data="appData"
            :options="appOptions"
            v-on:filterData="getAppFilterData"
          ></chartjs-line-chart>
        </div>
      </div>

      <b-card v-if="latestApp.length > 0">
        <h4 class="heading">
          {{ $t("LatestAppointment") }}
          <!-- <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            @click="activePrompt = true"
          /> -->
        </h4>

        <div class="export-table mt-5">
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="latestApp"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            @filtered="onFiltered"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>

            <template #cell()="data">
              {{ data.value || "NA" }}
            </template>
            <template #cell(day)="data">
              {{ $t(capitalize(data.item.day)) }}
            </template>
            <template #cell(current_status)="data">
              <span v-if="data.item.is_cancelled">
                {{ $t("Cancelled") }}
              </span>
              <span v-else>
                {{
                  data.item.current_status == "1"
                    ? $t("Completed")
                    : $t("Pending")
                }}
              </span>
            </template>
            <template #cell(payment_status)="data">
              {{
                data.item.payment_status == "1"
                  ? $t("Paid")
                  : data.item.payment_status != undefined &&
                    data.item.payment_status == "0"
                  ? $t("NotPaid")
                  : $t("Free")
              }}
            </template>
            <template #cell(action)="data">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="
                  $router.push('/company/appointment/show/' + data.item.id)
                "
              />
            </template>
          </b-table>
          <b-pagination
            v-if="rows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            class="float-right"
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsBarChart from "@/components/chart/ChartjsBarChart.vue";
import ChartjsPieChart from "@/components/chart/ChartjsPieChart.vue";
import ChartjsDoughnutChart from "@/components/chart/ChartjsDoughnutChart.vue";
import ChartjsLineChart from "@/components/chart/ChartjsLineChart.vue";
import ChangeTimeDurationDropdown from "@/components/chart/ChangeTimeDurationDropdown.vue";
import moment from "moment";
import vSelect from "vue-select";
import "vue2-datepicker/index.css";
import Department from "@/views/company/department/Form";

// For custom error message
import { Validator } from "vee-validate";
export default {
  data() {
    return {
      department_data: [],
      height: 200,
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["User", "Date", "Day", "StartTime", "EndTime"],
      headerVal: ["users", "date", "day", "start_time", "end_time"],
      activePrompt: false,
      activePromptCancel: false,
      val: true,
      message: "",
      status: 1,
      check: false,
      countAppointment: 0,
      countPending: 0,
      countCancelled: 0,
      countCompleted: 0,
      latestApp: [],
      selectedApp: "Current Month",
      appointmnetData: {},
      title: [],
      values: [],
      status: "",
      selected: "",
      appData: {},
      appOptions: {
        responsive: true,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                stepSize: 5,
              },
            },
          ],
        },
      },
      appTitle: "",
      popupActivo2: false,
      popupActivo3: false,
      totalRows: 1,
      unio_user: this.$store.getters.currentUser.is_unio,
      perPage: 5,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      fields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "day",
          label: "Day",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "start_time",
          label: "StartTime",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "end_time",
          label: "EndTime",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "current_status",
          label: "CurrentStatus",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: !this.is_unio ? "payment_status" : "",
          label: "PaymentStatus",
          sortable: true,
          sortDirection: "desc",
        },

        { key: "action", label: "Action" },
      ],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      temp: [],
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.getPieChartData();
        this.getAppFilterData(this.selectedApp);
      },
    },
    message(value) {
      if (value != "") {
        this.flag = "";
        this.check = true;
      } else {
        this.check = false;
      }
    },
  },
  components: {
    ChartjsPieChart,
    vSelect,
    ChartjsBarChart,
    ChangeTimeDurationDropdown,
    ChartjsDoughnutChart,
    ChartjsLineChart,
    StatisticsCardLine,
    Department,
  },
  mounted() {
    // Dispatched Orders
    this.getDashboardData(this.$store.getters.currentUser.id);
    this.getPieChartData();
    this.getAppFilterData("Current Month");
    this.loadLocale(this.$i18n.locale);
  },
  computed: {
    rows() {
      return this.latestApp.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    /**
     * get Appointment bar chart filter data
     */
    getAppFilterData(val) {
      this.selectedApp = val;
      let type = val.toLowerCase().replace(/\s/g, "_");
      this.appTitle = "Appointments";
      var data = {
        company_id: this.$store.getters.currentUser.company_id,
        staff_id: this.$store.getters.currentUser.id,
        type: type,
      };
      this.$store
        .dispatch("GetStaffChartData", data)
        .then((res) => {
          this.show = false;
          this.appData = {
            labels: Object.values(res.data.data.labels),
            datasets: [
              {
                data: res.data.data.values,
                borderColor: "#7367F0",
                fill: true,
              },
            ],
          };
          if (this.appData.labels.length == 12) {
            this.appData.labels = this.$t("monthNames");
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },

    /**
     * get appointment bar chart filter data
     */
    getPieChartData() {
      var data = {
        staff_id: this.$store.getters.currentUser.id,
      };
      this.$store
        .dispatch("GetStaffPieChartData", data)

        .then((res) => {
          this.show = false;
          var appointmnetLabels = [];
          var appointmnetValues = [];
          var preValue = 0;
          let temp = res.data.data;

          temp.map((el, index) => {
            if (el.status == "pending") this.countPending = el.count;
            if (el.status == "cancelled") this.countCancelled = el.count;
            if (el.status == "completed") this.countCompleted = el.count;
          });
          res.data.data.map((obj) => {
            if (obj.label != "Paid" && obj.label != "Unpaid") {
              appointmnetLabels.push(this.$t(obj.label));
              if (this.countAppointment > 0) {
                appointmnetValues.push(obj.count);
              } else {
                appointmnetValues.push(obj.count <= 0 ? -1 : obj.count);
              }
            }
          });

          this.appointmnetData = {
            labels: Object.values(appointmnetLabels),
            datasets: [
              {
                backgroundColor: ["#42ba96", "#FF9F43", "#EA5455"],
                data: appointmnetValues,
              },
            ],
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    // set randome colors
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    /**
     *
     * getDashboardData   method  for company login dashboard data
     **/
    getDashboardData(company_id) {
      this.show = true;

      this.$store
        .dispatch("GetStaffDashboardData", company_id)
        .then((res) => {
          if (res && res.data && res.data.data) {
            this.show = false;
            this.countAppointment = res.data.data.appointment_count;
            this.latestApp = res.data.data.latest_appointments;
            this.totalRows = this.latestApp.length;
            this.department_data = res.data.data.department_data;
            this.duration = this.department_data.duration;
            this.contact_number = res.data.data.contact_number;
            this.phone = res.data.data.contact_number;
          }
          else{
            throw new Error(`There is an error,status -${res.status} - ${res.statusText}`);
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : Staff.vue | Function : getDashboardData() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error = error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.latestApp;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = ["User", "Date", "Day", "StartTime", "EndTime"];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.filename = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * close   method  for close dialog box
     **/

    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
<style scoped>
/* .card {
  display: inline;
} */
</style>
<style lang="scss" scope>
.splitby.w-1\/3 {
  width: 27% !important;
}
a {
  color: #626262 !important;
}
.v-select .vs__dropdown-toggle {
  height: 34px;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
#hide {
  visibility: hidden !important;
}
.daterangepicker {
  left: 80% !important;
}

.heading {
  margin-bottom: 20px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.vs-input {
  width: 100%;
  margin-top: 10px;
}

.url {
  //  overflow-wrap: break-word;
  word-break: break-word;
}
.content {
  display: inline-flex;
}
.contact_number {
  padding: 8px !important;
}

.pad-10 {
  padding-bottom: 1.5rem !important;
}
.custom-height {
  height: 175px;
}
/*! rtl:end:ignore */
</style>  
  